import React from 'react'
import GolfTemplate from 'src/components/page/golf'
import { promoCodes } from 'src/constants/promoCodes'
import styled from 'styled-components'

export default (props) => {
  return (
    <StyledContainer>
      <GolfTemplate
        location={props.location}
        poster={'https://assets.fubo.tv/marketing/lp/images/posters/golf_Web_v3.png'}
        posterMobile={'https://assets.fubo.tv/marketing/lp/images/posters/golf_Mobile_v3.jpg'}
        subtitle={'Stream 120+ live events from the PGA Tour & more'}
        offerBanner={{
          title: ['Special offer for Troon members!', 'Save up to $100 on Fubo'],
        }}
        offerCode={promoCodes.troon_30}
        logo={'https://assets.fubo.tv/marketing/lp/images/partners/logo-troon.png'}
        logoHeight={'80px'}
        ctaText="Redeem offer"
        noIndex={true}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div``
